// packages/components/src/doctor-ai/PatientHeader.tsx
import React from 'react';
import type { Patient } from '@dopomogai/types';

export const PatientHeader: React.FC<{ patient: Patient | null }> = ({ patient }) => {
  // [KEY FIX] Guard against a null patient prop.
  if (!patient) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 p-4 border-b-2 border-black bg-white">
      <img
        src={patient.avatarUrl || '/avatars/default-avatar.png'}
        alt={patient.name}
        className="h-14 w-14 rounded-full border-2 border-black object-cover"
      />
      <div>
        <h2 className="text-xl font-bold text-slate-900">{patient.name}</h2>
        <p className="text-sm text-slate-600">{patient.status}</p>
      </div>
    </div>
  );
};